module.exports = __webpack_public_path__ + "img/icon_map_101_on.cb40e2b8.png";